// src/components/ImageViewer.js
import React from "react";
import { FiX, FiDownload } from "react-icons/fi";

const ImageViewer = ({ src, type, onClose }) => {
  const isImage = type === "image";
  const isVideo = type === "video";

  return (
    <div 
      className="fixed inset-0 z-[10000] bg-black/95 backdrop-blur-xl flex items-center justify-center p-4 md:p-12 animate-fade-in"
      onClick={onClose}
    >
      {/* Controls */}
      <div className="absolute top-6 right-6 flex items-center gap-4 z-50">
        <a
          href={src}
          download
          className="w-12 h-12 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all border border-white/10"
          onClick={(e) => e.stopPropagation()}
        >
          <FiDownload size={20} />
        </a>
        <button
          onClick={onClose}
          className="w-12 h-12 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all border border-white/10"
        >
          <FiX size={24} />
        </button>
      </div>

      {/* Main Content */}
      <div 
        className="relative max-w-full max-h-full flex items-center justify-center animate-zoom-in"
        onClick={(e) => e.stopPropagation()}
      >
        {isImage ? (
          <img 
            src={src} 
            alt="Full Preview" 
            className="max-w-full max-h-[90vh] object-contain rounded-2xl shadow-2xl shadow-black/50" 
          />
        ) : isVideo ? (
          <video 
            src={src} 
            controls 
            autoPlay 
            className="max-w-full max-h-[90vh] rounded-2xl shadow-2xl shadow-black/50" 
          />
        ) : (
          <div className="bg-white/5 p-12 rounded-[40px] border border-white/10 text-center space-y-4">
            <div className="w-20 h-20 bg-white/10 rounded-3xl flex items-center justify-center mx-auto text-white/20">
              <FiX size={40} />
            </div>
            <p className="text-white/60 font-black uppercase tracking-widest text-xs">Unsupported Format</p>
          </div>
        )}
      </div>

      {/* Hint */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/30 text-[10px] font-black uppercase tracking-[0.4em] pointer-events-none">
        Click anywhere to exit
      </div>
    </div>
  );
};

export default ImageViewer;
